import { ThemeOptions } from '@material-ui/core/styles/createTheme';

export const boulevardRioShopping: ThemeOptions = {
  palette: {
    primary: {
      main: '#0088a3',
    },
    secondary: {
      main: '#000000',
    },
    /**
     * @todo add tertiary do cliente
     */
    tertiary: {
      main: '#E2E543',
    },
    additionalColors: {
      promoHighligts: '#005b74',
    },
  },
};
